import { render, staticRenderFns } from "./CombineMenus.vue?vue&type=template&id=669de5b4&lang=pug"
import script from "./CombineMenus.vue?vue&type=script&lang=js"
export * from "./CombineMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports